import { Component, computed, input, signal } from '@angular/core';
import {
  InstallmentStatus,
  Order,
  OrderStatus,
} from '../../../../../../../models/order.model';
import { CurrencyPipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-order-details-data-card',
  imports: [CurrencyPipe, TooltipModule],
  templateUrl: './order-details-data-card.component.html',
})
export class OrderDetailsDataCardComponent {
  order = input<Order | null>();

  protected amountPaid = signal(0);
  protected paidInstallmentsQuantity = signal(0);
  protected amountDue = signal(0);

  isOrderCancelled = computed(() => {
    return this.order()?.status !== OrderStatus.Cancelled;
  });

  ngOnInit(): void {
    if (this.order() && this.order()?.paymentPlan.installments) {
      const paidInstallments = this.order()!.paymentPlan.installments.filter(
        (x) => x.status === InstallmentStatus.Paid && x.number > 0,
      );
      const downPayment = this.order()!.paymentPlan.installments.filter(
        (x) => x.number == 0,
      )[0];
      const paidAmount =
        paidInstallments.reduce((sum, x) => sum + x.totalAmount, 0) +
        downPayment.totalAmount;
      this.amountPaid.set(paidAmount);
      this.paidInstallmentsQuantity.set(paidInstallments.length);
      this.amountDue.set(this.order()!.paymentPlan.fullPrice - paidAmount);
    }
  }
}
